(function () {
  function loadGoogleAnalytics() {
    try {
      const gaScript = document.createElement("script");
      gaScript.async = true;
      gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-6BY990H12Z";
      document.head.appendChild(gaScript);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", "G-6BY990H12Z", { anonymize_ip: true });
    } catch (e) {
      console.warn("Analytics blocked:", e);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    const banner = document.getElementById("cookie-banner");
    const btnAccept = document.getElementById("btn-accept-cookies");
    const btnReject = document.getElementById("btn-reject-cookies");
    const cookieStatus = localStorage.getItem("cookies_accepted");

    if (cookieStatus === "true") {
      loadGoogleAnalytics();
    }

    const hideBanner = () => {
      if (banner) {
        banner.style.transition = "opacity 0.4s ease, visibility 0.4s ease";
        banner.style.opacity = "0";
        banner.style.visibility = "hidden";
        setTimeout(() => banner.remove(), 400);
      }
    };

    if (btnAccept) {
      btnAccept.addEventListener("click", () => {
        localStorage.setItem("cookies_accepted", "true");
        loadGoogleAnalytics();
        hideBanner();
      });
    }

    if (btnReject) {
      btnReject.addEventListener("click", () => {
        localStorage.setItem("cookies_accepted", "false");
        hideBanner();
      });
    }
  });
})();
